import { Alert, Divider, Skeleton } from "antd";
import { useEffect } from "react";
import { useFetchSeasonFixtures, useFetchStages } from "../../entities/api";
import AddNewSeriesForm from "./AddNewSeriesForm";
import SetQuantity from "./SetQuantity";

const AddNewSeriesFormWrapper = (props) => {
  const { handleSetSeriesQuantity, handleSetFormRef, series } = props;
  const { data: stages, isLoading: isStagesLoading } = useFetchStages({
    limit: 1000,
  });
  const {
    data: fixtures,
    refetch: fetchFixtures,
    isLoading: isFixturesLoading,
  } = useFetchSeasonFixtures({
    seriesCode: series?.seriesCode,
  });

  useEffect(() => {
    if (series) {
      fetchFixtures();
    }
  }, [fetchFixtures, series]);

  return (
    <>
      {Boolean(fixtures?.data?.length) && (
        <Alert
          style={{ marginBottom: "16px" }}
          message="This series has now been linked to a fixture. In order to edit the Series Type, Number of Fixtures or Stage you will need to un-link any fixtures from this series."
          type="warning"
          showIcon
        />
      )}
      {!isStagesLoading || !isFixturesLoading ? (
        <AddNewSeriesForm
          series={series}
          stages={stages}
          handleSetFormRef={handleSetFormRef}
          linkedFixtures={Boolean(fixtures?.data?.length)}
        />
      ) : (
        <Skeleton />
      )}
      {series ? (
        ""
      ) : (
        <>
          <Divider />
          <SetQuantity handleSetSeriesQuantity={handleSetSeriesQuantity} />
        </>
      )}
    </>
  );
};

export default AddNewSeriesFormWrapper;
